// Import controller interfaces
import {
    IAuthenticationController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import ApiController from './ApiController';
import {
    ErrorMessage
} from '@app/models/api';

export default class ProductionAuthenticationController extends ApiController implements IAuthenticationController {
     
    private readonly controllerUrl: string = 'v2/authentication';

    public async authenticatePolicyAccess(policyId: number): Promise<boolean> {
        let url: string = `${this.controllerUrl}/${policyId}`;

        try {
            let response: Response = await super.makeGetCall(url, undefined, undefined);
            return await response.json();
        }
        catch (error) {
            throw error;
        }
    }  

    public async authenticatePolicyAccessPublic(policyId: number, zipCode: string): Promise<boolean> {
        let url: string = `${this.controllerUrl}/${policyId}/public/${zipCode}`;

        try {
            let response: Response = await super.makeGetCall(url, undefined, undefined, false);
            return await response.json();
        }
        catch (error) {
            throw error;
        }
    }
}